import InfoPanel from 'emerald-ui/lib/InfoPanel';
import Container from 'emerald-ui/lib/Container';
import Row from 'emerald-ui/lib/Row';
import Col from 'emerald-ui/lib/Col';
import TextField from 'emerald-ui/lib/TextField';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: InfoPanel, componentName: 'InfoPanel' }], 'InfoPanel'),
  description: 'The InfoPanel is a Panel that toggles between two views.',
  codeSamples: [
    {
      title: 'Default',
      scope: { InfoPanel, Container, Row, Col, TextField },
      whiteBackground: true,
      code: `<InfoPanel>
  <InfoPanel.PrimaryView>
    <Container>
      <Row>
        <Col sm={3}>
          <p>
            <strong>Summary</strong>
          </p>
          <p>This is the summary of the section and what it does</p>
        </Col>
        <Col sm={4}>
          <p>
            <strong>Field 1</strong>
          </p>
          <p style={{ marginBottom: '40px' }}>Value for Field 1</p>
          <p>
            <strong>Field 2</strong>
          </p>
          <p style={{ marginBottom: '40px' }}>Value for Field 2</p>
        </Col>
        <Col sm={5}>
          <p>
            <strong>Field 3</strong>
          </p>
          <p style={{ marginBottom: '40px' }}>Value for Field 3</p>
          <p>
            <strong>Field 4</strong>
          </p>
          <p style={{ marginBottom: '40px' }}>Value for Field 4</p>
          <p>
            <strong>Field 5</strong>
          </p>
          <p style={{ marginBottom: '40px' }}>Value for Field 5</p>
        </Col>
      </Row>
    </Container>
  </InfoPanel.PrimaryView>
  <InfoPanel.SecondaryView>
    <Container>
      <Row>
        <Col sm={3}>
          <p>
            <strong>Summary</strong>
          </p>
          <p>This is the summary of the section and what it does</p>
        </Col>
        <Col sm={6}>
          <TextField label="Field 1" defaultValue="Value for Field 1" />
          <TextField label="Field 2" defaultValue="Value for Field 2" />
        </Col>
        <Col sm={3} />
      </Row>
    </Container>
  </InfoPanel.SecondaryView>
</InfoPanel>`,
    },
  ],
};
